export interface ConfirmOTPDto
{
    getMsisdn(): string;
    getLanguage(): string;
    getOtp(): string;

}

export class ConfirmOTPDtoImpl implements ConfirmOTPDto
{
    private msisdn: string;
    private language: string;
    private otp: string;


    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getOtp(): string 
    {
        return this.otp;
    }
    setOtp(otp: string)
    {
        this.otp = otp;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/otp/confirmotp/confirmotpdto.tsx